import { ArticleParagraph1 } from '@cian/ui-kit';

import { Children, type FC } from 'react';

import styles from './AboutTab.css';

interface IAboutTabProps {
  firstColumnParagraphs?: string[];
  secondColumnParagraphs?: string[];
}

export const AboutTab: FC<IAboutTabProps> = ({ firstColumnParagraphs, secondColumnParagraphs }) => {
  return (
    <div className={styles['tab']}>
      <div className={styles['tab__item']}>
        {Children.map(firstColumnParagraphs, paragraph => (
          <div className={styles['tab__description']}>
            <ArticleParagraph1>{paragraph}</ArticleParagraph1>
          </div>
        ))}
      </div>

      <div className={styles['tab__item']}>
        <div className={styles['tab__media']}>
          {Children.map(secondColumnParagraphs, paragraph => (
            <div className={styles['tab__description']}>
              <ArticleParagraph1>{paragraph}</ArticleParagraph1>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
